import React, { useState, useEffect } from "react";


// import Archive from "../Archive/Archive";
function LiveComponent() {

    // State to store the selected hive and the list of hives
    const [selectedHive, setSelectedHive] = useState("");
    const [hives, setHives] = useState({});
    const [videoUrl, setVideoUrl] = useState("");
    const [error, setError] = useState(null);
    const baseURL = 'https://appmais-dev.cs.appstate.edu'
    const videoBasedUrl = `${baseURL}/videos/`

    //TailwindCss Styling
    const dropDownCss = "px-1 text-sm bg-gray-100 border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 " +
        "focus:ring focus:ring-indigo-200 focus:ring-opacity-50 mt-4";
    const beeThemedButton = "bg-yellow-400 text-black font-semibold px-4 py-2 rounded-lg hover:bg-yellow-500 " +
        "focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-opacity-50 mt-7";

    // Function to get today's date in YYYY-MM-DD format
    const getFormattedDate = () => {
        const now = new Date();
        return now.toISOString().split("T")[0];
    };

    // Function to get current time rounded to the nearest 5 minutes in HH:MM:SS AM/PM format
    const getRoundedTime = () => {
        const now = new Date();

        if (now.getMinutes() % 5 === 0) {
            now.setMinutes(now.getMinutes() - 5);
        }
        // Subtract 6 minutes if the current time is 1 minute past a 5-minute increment
        else if (now.getMinutes() % 5 === 1) {
            now.setMinutes(now.getMinutes() - 6);
        } else {
            // Otherwise, round down to the nearest 5-minute increment
            now.setMinutes(now.getMinutes() - now.getMinutes() % 5);
        }

        now.setSeconds(0);

        const hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "pm" : "am";
        const formattedHours = hours % 12 || 12;  // Convert 24h to 12h format

        return `${formattedHours}:${minutes}:00 ${ampm}`;
    };

    //Function to convert a String representing a time to query format, also a string
    const convertTimeToQuery = (timeString) => {
        // Extract hours, minutes, seconds, and am/pm parts from the string
        const [time, amOrPm] = timeString.split(" ");
        const [hoursString, minutesString, secondsString] = time.split(":");
        let hours = parseInt(hoursString, 10);

        // Convert 12-hour format to 24-hour format
        if (amOrPm === "pm" && hours !== 12) {
            hours += 12;
        }
        if (amOrPm === "am" && hours === 12) {
            hours = 0;
        }

        return `${String(hours).padStart(2, "0")}:${minutesString}:${secondsString}`;
    };

    //Loads Hive whe page is loaded
    useEffect(() => {
        fetch(`${baseURL}/api/hives`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch hives");
                }
            })
            .then(data => {
                setHives(data);
            })
            .catch(error => {
                setError(error.toString());
            });
    }, []); // The empty array ensures this runs once on mount

    // Handler for changing the hive selection
    const handleHiveChange = (event) => {
        setSelectedHive(event.target.value);
    };

    /*
        Creates the specifics of the url needed for the endpoint
     */
    function createSpecificVideoUrl(filePath) {
        // Split the path at 'appmais/' and take the part after it
        const splitPath = filePath.split("appmais/");
        const latterHalfPath = splitPath.length > 1 ? splitPath[1] : "";

        // Replace the file extension from .h264 to .mp4
        return latterHalfPath.replace(/\.h264$/, ".mp4");
    }

    //Uses Route to fetch video file path based on selected hive, date and time
    const fetchVideoFilePath = (selectedHive, pdate, ptime) => {
        const filepathUrl = `${baseURL}/api/videofiles/${encodeURIComponent(selectedHive)}/${encodeURIComponent(pdate)}/${encodeURIComponent(ptime)}/filepath`;

        fetch(filepathUrl)
            .then(async response => {
                if (response.ok) {
                    const data = await response.json();
                    console.log(data);
                    // Added validation to ensure the API returned a non-empty array with a FilePath,
                    // and applied encodeURIComponent to each path segment so URLs with spaces or
                    // special characters won't break. If no valid FilePath exists, show an error
                    // instead of crashing.
                    const filePath = data?.FilePath || (Array.isArray(data) && data[0]?.FilePath);
                    if (!filePath) {
                        setError("No video found for the selected time window.");
                        setVideoUrl("");
                        return;
                    }
                    const streamUrl = `${baseURL}/api/videos/stream?h264=${encodeURIComponent(filePath)}`;
                    console.log(streamUrl);
                    setError(null);
                    setVideoUrl(streamUrl);
                    console.log("FilePath:", filePath);
                    console.log("VideoURL:", streamUrl);
                    return;
                }

                if (response.status === 404) {
                    // Fallback 1: try that day's times and use the most recent clip
                    const timesUrl = `${baseURL}/api/videofiles/${encodeURIComponent(selectedHive)}/times/${encodeURIComponent(pdate)}`;
                    const timesRes = await fetch(timesUrl);
                    if (timesRes.ok) {
                        const times = await timesRes.json();
                        if (Array.isArray(times) && times.length > 0) {
                            const fallbackFilePathSameDay = times[0]?.FilePath || times[0]?.filePath;
                            if (fallbackFilePathSameDay) {
                                const streamUrl = `${baseURL}/api/videos/stream?h264=${encodeURIComponent(fallbackFilePathSameDay)}`;
                                console.log(streamUrl);
                                setError(null);
                                setVideoUrl(streamUrl);
                                console.log("Fallback (same day) FilePath:", fallbackFilePathSameDay);
                                console.log("VideoURL:", streamUrl);
                                return;
                            }
                        }
                    }

                    // Fallback 2: no videos for that day — use the latest available day
                    const daysUrl = `${baseURL}/api/videofiles/${encodeURIComponent(selectedHive)}/days`;
                    const daysRes = await fetch(daysUrl);
                    if (!daysRes.ok) throw new Error("Failed to fetch available days");

                    const days = await daysRes.json(); // e.g., ["09/24/2025", "09/25/2025"]
                    if (!Array.isArray(days) || days.length === 0) {
                        throw new Error("No videos available for this hive.");
                    }

                    // pick the latest day <= requested date (or just the last day if parsing fails)
                    const requested = new Date(pdate);
                    const toDate = (s) => new Date(s);
                    let chosen = null;
                    for (let i = days.length - 1; i >= 0; i--) {
                        const d = toDate(days[i]);
                        if (!isNaN(d) && (isNaN(requested) || d <= requested)) { chosen = days[i]; break; }
                    }
                    if (!chosen) chosen = days[days.length - 1];

                    const timesRes2 = await fetch(`${baseURL}/api/videofiles/${encodeURIComponent(selectedHive)}/times/${encodeURIComponent(chosen)}`);
                    if (!timesRes2.ok) throw new Error("Failed to fetch times for latest day");

                    const times2 = await timesRes2.json();
                    if (!Array.isArray(times2) || times2.length === 0) throw new Error("No videos found on latest day.");

                    const fallbackFilePath = times2[0]?.FilePath || times2[0]?.filePath;
                    if (!fallbackFilePath) throw new Error("No video file path available.");

                    const streamUrl = `${baseURL}/api/videos/stream?h264=${encodeURIComponent(fallbackFilePath)}`;
                    console.log(streamUrl);
                    setError(null);
                    setVideoUrl(streamUrl);
                    console.log("Fallback (latest day) chosen:", chosen);
                    console.log("VideoURL:", streamUrl);
                    return;
                }

                throw new Error("Failed to fetch video file path");
            })
            .catch(error => {
                setError(error.toString());
                setVideoUrl("");
                console.log("Error: " + error);
            });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        // console.log("Hive: " + selectedHive);
        // console.log("date " + getFormattedDate());
        // console.log("Time: " + convertTimeToQuery(getRoundedTime()));
        fetchVideoFilePath(selectedHive, getFormattedDate(), convertTimeToQuery(getRoundedTime()));
    };


    return (

        <div className="flex-container">
            <div className="sect main-content">
                <div className="min-h-[85vh]">
                    <h1 className="font-bold text-4xl text-center pb-3 mt-5">Stream</h1>
                    <form>
                        <div className="dropdown-div">
                            <select
                                name="HiveSelect"
                                onChange={handleHiveChange}
                                className={dropDownCss}
                                value={selectedHive}
                            >
                                <option value="">Choose a Hive</option>
                                {Object.values(hives).map((hive) => (
                                    <option key={hive} value={hive}>{hive}</option>
                                ))}
                            </select>
                        </div>
                        <button className={beeThemedButton} onClick={onSubmit}>View</button>
                    </form>
                    <div className="video-div">

                        {videoUrl && (

                            <video className="video-div" id="video" src={videoUrl} controls autoPlay muted playsInline>
                                Your browser doesn't support HTML5 video.
                            </video>

                        )}
                        {error && (
                            <p className="mt-2 text-red-600 text-sm">{error}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}

export default LiveComponent;
